
export class ExecuteFormModel {
    Id: string;
    Name: string;
    ComponentId: string;
    FormType: string;
    TerminalType: TerminalType;
    ActualParameters: ActualParameter[];
    formFormatId: string;
    formatConfigId: string;
}
export class ActualParameter {
    Name: string;
    NameDisPlay?: string;
    Value: string;
    ValueText?: string;
    Tag?: string;
}
export enum TerminalType {
    PC = 'PC',
    MOBILE = 'MOBILE',
    ALL = 'ALL'
}
